export const TourInfoData = [
  {
    iconClass: "envelope",
    text: "   Email",
    spanText: "William@jourrapide.com",
  },
  {
    iconClass: "calendar",
    text: "   BOD",
    className: "ttl-sm-mb-0",
    spanText: "02 January 1988",
  },
];

export const TourAddressData = [
  {
    colClass: "mt-0 mt-sm-3",
    iconClass: "phone",
    text: "   Contact Us",
    className: "ttl-xs-mt",

    spanText: "US 310-273-0666",
  },
  {
    iconClass: "location-arrow",
    text: "   Location",
    className: "ttl-sm-mb-0",
    spanText: "4377 Libby Street Beverly Hills",
  },
];

export const SocialData = [
  {
    href: "https://www.facebook.com/",
    icon: "fa fa-facebook",
  },
  {
    href: "https://accounts.google.com/",
    icon: "fa fa-google-plus",
  },
  {
    href: "https://twitter.com/",
    icon: "fa fa-twitter",
  },
  {
    href: "https://www.instagram.com/",
    icon: "fa fa-instagram",
  },
  {
    href: "https://rss.app/",
    icon: "fa fa-rss",
  },
];

export const CommonFooterData = [
  {
    className: "b-r-gray pe-3",
    icon: "heart",
    text: " Like",
  },
  {
    className: "b-r-gray pe-3",
    icon: "comment",
    text: " Comment",
  },
  {
    icon: "paper-plane",
    text: " Share",
  },
];

//Tour
export const TourSteps = [
  {
    target: ".step1",
    content: "This is Berlin profile",
  },
  {
    target: ".step2",
    content: "Change Berlin profile image here",
  },
  {
    target: ".step3",
    content: "This is your profile details",
  },
  {
    target: ".step4",
    content: "This is your social details",
  },
  {
    target: ".step5",
    content: "This is your first Post",
  },
];
